import script from "./TweetSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./TweetSearch.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__